module.exports = __webpack_public_path__ + "img/muscle.41d0ef49.gif";